<div class="content-wrapper">

  <div class="page-title-box">
    <h4>Dealer List</h4>
  </div>

  <div class="card card-nobody">
    <div class="card-body">
      <ng-container *ngIf="newDealers && newDealers.length > 0 && isAdmin && !isAdminViewerRole">
        <div class="row mb-12px">
          <div class="col-lg-12 col-sm-12">
            <div class="position-relative">
              <div class="new-dealer-container">
                <perfect-scrollbar [config]="{useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: true}">
                  <div class="d-flex flex-row">
                    <div (click)="onBoarding(newDealer)" *ngFor="let newDealer of newDealers" class="new-dealer-card">
                      <div class="row new-dealer-card-row">
                        <div class="col-2 new-dealer-card-name">Name</div>
                        <div class="col-3 new-dealer-card-value">{{ newDealer.name }}</div>
                        <div class="col-1 new-dealer-card-name">Status</div>
                        <div class="col-3 new-dealer-card-value">{{ newDealer.status }}</div>
                        <div class="col-1 new-dealer-card-name">Request</div>
                        <div class="col-2 new-dealer-card-value">{{ newDealer.onboarding?.requestDate | hqDate }}</div>
                      </div>
                      <div class="row">
                        <div class="col-2 new-dealer-card-name">Contact #</div>
                        <div class="col-3 new-dealer-card-value">{{ newDealer.tel | tel }}</div>
                        <div class="col-1 new-dealer-card-name">Email</div>
                        <div class="col-6 new-dealer-card-value">{{ newDealer.email }}</div>
                      </div>
                    </div>
                  </div>
                </perfect-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="row mb-0">
        <div class="col-lg-8 col-sm-8">
          <div class="row search-box">
            <div *ngIf="[companies.Sea, companies.Seca].includes(company)"
                 class="col-lg-4 position-relative">
              <ng-select (change)="changeDealer($event)"
                         [items]="dealerSelectGroup"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         placeholder="All Dealers">
              </ng-select>
            </div>
            <div class="col-lg-5 mb-2">
              <div class="position-relative">
                <input [formControl]="searchText"
                       class="form-control border-light rounded"
                       placeholder="Search..."
                       type="search">
                <i class="uil uil-search search-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-4">
          <div class="mt-4 mt-sm-0 d-flex justify-content-sm-end gap-4">
            <div
              *ngIf="[companies.Sea].includes(company) || ([companies.Seca].includes(company) && isAdminOnly && isHq)"
              class="col-lg-1 mt-4px mr-12px">
              <div class="position-relative">
                <button (click)="exportResult()"
                        class="btn btn-primary btn-sm"
                        type="submit">Export
                </button>
              </div>
            </div>
            <button (click)="modalOpen()" *ngIf="showNew && !isAdminViewerRole" class="btn btn-dark" type="button">
              <font-awesome>New</font-awesome>
            </button>
          </div>
        </div>
      </div>
      <div [ngClass]="{'bt': showDetail}" class="table-wrapper">
        <app-dp-list (pageEvent)="onPageEvent($event)"
                     (toggleDetail)="showDetail=$event"
                     [pagedResponse]="pagedResponse"
                     [selectedItem]="selectedData"
                     [showDetail]="showDetail">
          <table
            [ngClass]="{
              'table': !showDetail,
              'table-list' : !showDetail,
              'align-middle': !showDetail,
              'table-nowrap': !showDetail,
              'table-check': !showDetail,
              'w-100': true
              }">
            <thead>
            <tr>
              <th [hidden]="showDetail">No.</th>
              <th [hidden]="showDetail">Name</th>
              <th *ngIf="isAdmin" [attr.data-sort-fields]="'bpNo'" [hidden]="showDetail">BP#</th>
              <th [attr.data-sort-fields]="'address.city'" [hidden]="showDetail">City</th>
              <th [attr.data-sort-fields]="'address.state'" [hidden]="showDetail">State</th>
              <th *ngIf="[companies.Sea, companies.Seca].includes(company)" [attr.data-sort-fields]="'hq'"
                  [hidden]="showDetail">HQ
              </th>
              <th *ngIf="isAdmin && [companies.Sea, companies.Seca].includes(company)"
                  [attr.data-sort-fields]="'hqBpNo'" [hidden]="showDetail">HQ BP #
              </th>
              <th [hidden]="showDetail">Phone #</th>
              <th [hidden]="showDetail">Email</th>
              <th [hidden]="showDetail">Contact Person</th>
              <th [hidden]="showDetail">Status</th>
              <th [attr.data-sort-fields]="'auth.createdAt'" [hidden]="showDetail">Created</th>
            </tr>
            </thead>

            <tbody>
            <tr (click)="selectRow(dealer)" *ngFor="let dealer of dealerData; let i=index;"
                [attr.data-index]="i"
                [ngClass]="{
                  'hq-row': dealer.hq === true && [companies.Seca].includes(company),
                  'active': dealer.bpNo === selectedData?.bpNo
                }"
            >
              <ng-container *ngIf="!showDetail; else detailListCols">
                <td>{{ i + 1 }}</td>
                <td>{{ dealer.name }}</td>
                <td *ngIf="isAdmin">{{ dealer.bpNo }}</td>
                <td>{{ dealer.address?.city }}</td>
                <td>{{ dealer.address?.state }}</td>
                <td *ngIf="[companies.Sea, companies.Seca].includes(company)">
                  <dp-badge [color]="dealer.hq ? '#a32cca':'#b8b8ee'"
                            [size]="''"
                            [text]="dealer.hq | booleanToString"></dp-badge>
                </td>
                <td *ngIf="isAdmin && [companies.Sea, companies.Seca].includes(company)">{{ dealer.hqBpNo }}</td>
                <td>{{ dealer.tel | telNoCountry }}</td>
                <td>{{ dealer.email }}</td>
                <td>{{ dealer.contactPerson }}</td>
                <td>
                  <dp-badge
                    [color]="dealer.status === 'ACTIVE' ? '#2E81E8FF' : dealer.status === 'REQUESTED' ? '#988f8f' : '#f30707'"
                    [size]="'wd-xxs'" [text]="dealer.status"></dp-badge>
                </td>
                <td>{{ dealer.auth?.createdAt | hqDate }}</td>
              </ng-container>

              <ng-template #detailListCols>
                <td class="detail-area-container">
                  <div class="detail-area">
                    <div [ngClass]="{
                    'detail-row': true,
                    'list-card-container': true,
                    'detail-row-active': selectedData.bpNo === dealer.bpNo
                    }">
                      <div class="row">
                        <div class="col-5 detail-font-bold-12px">{{ dealer.name }}</div>
                        <div class="col-4 detail-font-bold-12px">{{ dealer.address?.city }}
                          / {{ dealer.address?.state }}
                        </div>
                        <div *ngIf="[companies.Sea, companies.Seca].includes(company)" class="col-2 detail-item-right">
                          <dp-badge [color]="dealer.hq === true ? '#a32cca' : '#b8b8ee'"
                                    [size]="'wd-fit'" [text]="dealer.hq === true ? 'HQ' : 'STORE'"></dp-badge>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5 detail-font-bold-12px">{{ dealer.status === 'ACTIVE' ? dealer.bpNo : '' }}
                        </div>
                        <div class="col-4 detail-font-bold-12px">{{ dealer.tel | telNoCountry }}</div>
                        <div class="col-3 detail-item-right">
                          <dp-badge
                            [color]="dealer.status === 'ACTIVE' ? '#2E81E8FF' : dealer.status === 'REQUESTED' ? '#988f8f' : '#f30707'"
                            [size]="'wd-fit'"
                            [text]="dealer.status"></dp-badge>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-template>
            </tr>
            </tbody>
          </table>
        </app-dp-list>

        <app-dp-detail *ngIf="showDetail && selectedData" [showDetail]="showDetail">
          <app-dealer-detail (changeView)="isProductView = !isProductView" (detailUpdateEvent)="reload($event)"
                             *ngIf="!isProductView"
                             [dealerInfo]="selectedData"></app-dealer-detail>
          <app-products-view (changeView)="isProductView = !isProductView" *ngIf="isProductView"
                             [dealerStore]="selectedData"
                             class="w-100"></app-products-view>
        </app-dp-detail>
      </div>

    </div><!-- end card body -->
  </div><!-- end card -->
</div>
